"use strict";
// Copyright © Veeam Software Group GmbH
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Policy64Icon = void 0;
const react_1 = __importDefault(require("react"));
const Policy64Icon = () => (react_1.default.createElement("svg", { viewBox: "0 0 64 64" },
    react_1.default.createElement("path", { d: "M36.99,50v-3H8v3c0,3.285,1.982,5.946,4.438,5.992-.022,0-.042,.008-.063,.008h27.272c-1.762-1.484-2.743-3.698-2.657-6Z", fill: "#716d65" }),
    react_1.default.createElement("path", { d: "M52.057,8.051c-2.281,.291-4.067,2.842-4.067,5.96v2.989h8.01v-3c0-3.062-1.721-5.583-3.943-5.949Z", fill: "#716d65" }),
    react_1.default.createElement("path", { d: "M46.99,17.011v-3c-.087-2.309,.899-4.528,2.671-6.011H18.5c-2.485,0-4.5,2.686-4.5,6V46h24v1h-.01v3c0,3.285,1.982,5.946,4.437,5.992-.021,0-.041,.008-.062,.008h.135c2.485,0,4.5-2.687,4.5-6V18h-.01v-.989Zm-5.99,21.989H20v-1h21v1Zm0-9H20v-1h21v1Zm0-9H20v-1h21v1Z", fill: "#716d65" })));
exports.Policy64Icon = Policy64Icon;
//# sourceMappingURL=Policy64Icon.js.map